import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchPDDWarehouse = createAsyncThunk(
    'fetchPDDWarehouse',
    async ({ jwtBearer, movement }) => {
        const response = await fetch(`${BASE_URL}pdd/get/warehouse/data/`, {
            headers: {
                Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
            }
        })
        return response.json()
    }
)

const pddWarehouseDataSlice = createSlice({
    name: 'pddWarehouseDataSlice',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: builder => {
        builder.addCase(fetchPDDWarehouse.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchPDDWarehouse.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchPDDWarehouse.rejected, (state, action) => {
            console.log('Error', action.payload)
            state.isError = true
        })
    }
})

export default pddWarehouseDataSlice.reducer
